(() => {
    document.querySelectorAll('.swiper-container').forEach(container => {
        if (container.classList.contains('services')) return;

        const slides = container.querySelectorAll('.swiper-slide');

        const wrapper = container.querySelector('.swiper-wrapper');

        let exists = false;
        let swiper = null;

        const options = {
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                // when window width is >= 640px
                740: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1080: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        };

        const handleResize = () => {
            if (window.innerWidth <= 842) {
                if (!exists && !swiper) {
                    swiper = new Swiper(container, options);
                }
                return;
            }

            if (swiper) {
                container.classList.remove('swiper-container-initialized');
                wrapper.style.transform = "";
                swiper.destroy(true, false);
                slides.forEach(el => {
                    el.style.width = "100%";
                })
            }
        }

        handleResize();

        let resizeTimeout = null;

        window.addEventListener('resize', e => {
            if (resizeTimeout) clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(() => {
                handleResize();
            }, 30)
        });

        // const swiper = new Swiper(container, options);
    });

    document.querySelectorAll('.swiper-container.services').forEach(container => {

        const wrapper = container.querySelector('.swiper-wrapper');

        const slides = container.querySelectorAll('.swiper-slide');

        let exists = false;
        let swiper = null;

        const options = {
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                // when window width is >= 640px
                740: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1080: {
                    slidesPerView: 4,
                    spaceBetween: 40
                }
            }
        };

        const handleResize = () => {
            if (window.innerWidth <= 842) {
                if (!exists && !swiper) {
                    swiper = new Swiper(container, options);
                }
                return;
            }

            if (swiper) {
                container.classList.remove('swiper-container-initialized');
                wrapper.style.transform = "";
                swiper.destroy(true, false);
                slides.forEach(el => {
                    el.style.width = "100%";
                })
            }
        }

        handleResize();

        let resizeTimeout = null;

        window.addEventListener('resize', e => {
            if (resizeTimeout) clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(() => {
                handleResize();
            }, 30)
        });


    });

})();
